import React, {useEffect} from 'react';
import logo from './logo.svg';
import './App.css';
import PreLoader from './components/PreLoader';
import SearchPopup from './components/SearchPopup';
import MainHeader from './components/MainHeader';
import MobileMenu from './components/MobileMenu';
import BannerSection from './components/BannerSection';
import FeatureSection from './components/FeatureSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import Testimonial from './components/Testimonial';
import ScrollToTopButton from './components/ScrollToTopButton';

const App = () => {

    useEffect(() => {
        const script = document.createElement('script');
        script.src = "assets/js/script.js";
        script.async = true;
        document.body.appendChild(script);
      return () => {
          document.body.removeChild(script);
        }
      }, []);

  return (
    <div className="App">
      <div className="boxed_wrapper">
        {/* <PreLoader /> */}
        <SearchPopup />
        <MainHeader />
        <MobileMenu />
        <BannerSection />
        <AboutSection />
        <FeatureSection />
        <Testimonial />
        <Footer />
        <ScrollToTopButton />
      </div>
    </div>
  );
}

export default App;
